import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {DisplayDecimalComponent} from './display-decimal.component';
import {SlashedDisplayDecimalsComponent} from './slashed-display-decimals';

@NgModule({
    imports:      [
        CommonModule
    ],
    declarations: [
        DisplayDecimalComponent,
        SlashedDisplayDecimalsComponent
    ],
    exports:      [
        DisplayDecimalComponent,
        SlashedDisplayDecimalsComponent
    ]
})
export class DisplayDecimalModule {}
